import type { LucideIcon } from "lucide-react"
import {
  Activity,
  Award,
  BadgeDollarSign,
  Building,
  Building2,
  CalendarCheck,
  CheckSquare,
  CircleDot,
  Factory,
  FileText,
  Fuel,
  IdCard,
  Landmark,
  Layers,
  ListOrdered,
  MapPin,
  MessageSquare,
  Paperclip,
  Plane,
  PlaneLanding,
  PlaneTakeoff,
  Receipt,
  Route,
  Tag,
  UserCog,
  UserRound,
  Users,
  Wallet,
} from "lucide-react"

export const NODE_ICONS: Record<string, LucideIcon> = {
  client: Building2,
  user: UserCog,
  segment: Tag,
  contact: Users,
  contact_channel: MessageSquare,
  passenger: UserRound,
  travel_document: IdCard,
  account_holder: Wallet,
  manufacturer: Factory,
  aircraft_model: Layers,
  aircraft: Plane,
  operator: Building,
  operator_safety_rating: Award,
  crew_member: IdCard,
  airport: MapPin,
  fbo: Fuel,
  trip: Route,
  leg: PlaneLanding,
  empty_leg: PlaneTakeoff,
  quote: FileText,
  quote_line_item: ListOrdered,
  booking: CalendarCheck,
  invoice: Receipt,
  invoice_line_item: ListOrdered,
  payment: BadgeDollarSign,
  document: Paperclip,
  task: CheckSquare,
  activity: Activity,
}

export function nodeIcon(type: string): LucideIcon {
  return NODE_ICONS[type] ?? (type === "airports" ? Landmark : CircleDot)
}
